export default {
  SET_UNREAD_NOTIFICATION (state, items) {
    state.unreadNotification = items
  },

  ADD_UNREAD_NOTIFICATION (state, item) {
    state.unreadNotification.unshift(item)
  },

  CLEAR_UNREAD_NOTIFICATION (state, imei) {
    const newData = []
    state.unreadNotification.map(item => {
      if(item.imei !== imei) {
        newData.push(item)
      }
    })

    state.unreadNotification = newData
  }
}